import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/fold2/BgImg01.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Custom Mobile Solutions for Your Business Needs</h2>
            </div>
            <p>
              Experience the power of personalized solutions at TekRevol. We
              deeply understand your business needs, forging custom mobile
              solutions that drive success
            </p>
            <p>
              Elevate efficiency, engage customers seamlessly, and stay ahead in
              your industry. Let's shape the perfect mobile solution for your
              business, together.
            </p>
            <Link
              to="https://www.tekrevol.com/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
